/**
 * Display Mode Context
 */

import { createContext } from 'react';
import type { DisplayModeConfig } from '../types/displayMode';

// Create context with undefined default
export const DisplayModeContext = createContext<DisplayModeConfig | undefined>(
  undefined
);
